import React from 'react';
import { compose } from 'redux';
import actions from 'fantastic/actions';
import connectActions from 'shared/lib/connectActions';
import connectProps from 'shared/lib/connectProps';

const HistoryNavigationButtons = ({ undo, redo, versions: { currentIndex, snapshots } }) => {
  const canRedo = snapshots[currentIndex + 1] !== undefined
  const canUndo = snapshots[currentIndex - 1] !== undefined
  return (
    <div className="btn-group">
      <button className="btn btn-form" onClick={() => undo()} disabled={!canUndo}>
        <i className="fa fa-mail-reply"></i>
      </button>
      <button className="btn btn-form" onClick={() => redo()} disabled={!canRedo}>
        <i className="fa fa-share"></i>
      </button>
    </div>
  );
};

export default compose(
  connectActions({
    undo: actions.versionsUndo,
    redo: actions.versionsRedo }),
  connectProps('versions')
)(HistoryNavigationButtons);
